<template>
  <div>
    <v-row>
      <v-col cols="12">
        Por padrão, as empresas podem comprar os produtos do catálogo <b>à vista</b>.
        Abaixo você pode configurar os prazos específicos e o valor mínimo comprado para
        cada prazo.
      </v-col>
    </v-row>
    <div v-if="!hasPrazo"
         align="center"
         class="mb-5 mt-5">
      Ainda não há nenhum prazo configurado,
      <a @click="onAddPrazo">clique aqui</a>
      para adicionar
    </div>
    <v-simple-table v-if="hasPrazo">
      <template v-slot:default>
        <thead>
        <tr>
          <th>Prazo de pagamento</th>
          <th>Valor mínimo de compra</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in catalogo.prazosPagamentos"
            :key="`i${item.internalKey}-${item.id}`">
          <td>
            <px-autocomplete-prazo-pagamento
              dense
              :error="$v.catalogo.prazosPagamentos.$each[index].prazoPagamento.$error"
              @blur="$v.catalogo.prazosPagamentos.$each[index].prazoPagamento.$touch()"
              v-model="item.prazoPagamento"/>
          </td>
          <td>
            <px-input-money
              dense
              ref="valorMinimo"
              class="required mt-2 mb-2"
              label="Valor mínimo"
              :error="$v.catalogo.prazosPagamentos.$each[index].valorMinimo.$error"
              @blur="$v.catalogo.prazosPagamentos.$each[index].valorMinimo.$touch()"
              v-model="item.valorMinimo"
            />
          </td>
          <td>
            <v-btn icon @click="removePrazo(index)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-row>
      <v-col cols="12" class="text-right">
        <v-btn small color="primary" @click="onAddPrazo">
          <v-icon small>mdi-plus</v-icon>
          Novo prazo
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="mt-5">
      <v-col cols="12">
        <v-btn color="primary"
               :loading="loading"
               @click="emitReady">
          Salvar
        </v-btn>
        <v-btn class="ml-2" text @click="emitPrevious">Voltar</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Vue from 'vue';
import { required } from 'vuelidate/lib/validators';
import validationMixin from '@/mixins/validation-mixin';
import { uniqueId } from 'lodash';

const itemState = () => ({
  internalKey: uniqueId(),
  prazoPagamento: null,
  valorMinimo: null,
});

export default {
  mixins: [validationMixin],
  props: {
    catalogo: Object,
    loading: Boolean,
  },
  data() {
    return {
      valor: null,
      prazoPagamento: null,
    };
  },
  computed: {
    hasPrazo() {
      return this.catalogo.prazosPagamentos && this.catalogo.prazosPagamentos.length;
    },
  },
  methods: {
    emitReady() {
      if (this.validateForm()) {
        return;
      }
      this.$emit('ready');
    },
    emitPrevious() {
      this.$emit('previous');
    },
    onAddPrazo() {
      if (!this.catalogo.prazosPagamentos) {
        Vue.set(this.catalogo, 'prazosPagamentos', []);
      }
      this.catalogo.prazosPagamentos.push(itemState());
    },
    removePrazo(index) {
      this.catalogo.prazosPagamentos.splice(index, 1);
    },
  },
  validations: {
    catalogo: {
      prazosPagamentos: {
        $each: {
          prazoPagamento: {
            required,
          },
          valorMinimo: {
            required,
          },
        },
      },
    },
  },
};
</script>
